import { useHistory } from 'react-router-dom'
import { historyGoBackState } from 'shared/constants/history'

const useGoBackState = () => {
  const history = useHistory()

  const goBack = (fallbackPath: string) => {
    if (history.location.state === historyGoBackState) {
      history.goBack()
      return
    }
    history.push(fallbackPath)
  }

  const push = (path: string) =>
    history.push({
      pathname: path,
      state: historyGoBackState,
    })

  return { goBack, push }
}

export default useGoBackState
